export default "__VITE_ASSET__DwZd$_7j__"